import axios from "axios";

const API_URL = process.env.REACT_APP_API_BASE_URL;

export interface LoginRequest {
  email: string;
  password: string;
}

export interface RefreshRequest {
  refreshToken: string;
}

export interface LoginResponse {
  token: string;
  refreshToken: string;
}

export class LoginService {
  static async login(data: LoginRequest): Promise<LoginResponse> {
    console.log(API_URL);
    const response = await axios.post<LoginResponse>(`${API_URL}/Auth/login`, data);
    localStorage.setItem("token", response.data.token);
    localStorage.setItem("refreshToken", response.data.refreshToken);
    return response.data;
  }

  static async refreshToken(): Promise<LoginResponse | null> {
    const refreshToken = localStorage.getItem("refreshToken");
    if (!refreshToken) return null;

    try {
      const response = await axios.post<LoginResponse>(`${API_URL}/Auth/refresh`, { refreshToken });
      return response.data;
    } catch (error) {
      console.error("Token refresh failed", error);
      return null;
    }
  }

  static async logout(): Promise<boolean> {
    const refreshToken = localStorage.getItem("refreshToken");
    if (!refreshToken) return false;

    try {
      await axios.post(`${API_URL}/Auth/logout`, { refreshToken });
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      window.location.href = "/"; 
      return true;
    } catch (error) {
      console.error("Logout failed", error);
      return false;
    }
  }

  static getToken(): string | null {
    return localStorage.getItem("token");
  }
}
